import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Location } from '@one-thd/sui-icons';

// Ported one-to-one from @thd-olt-component-react/active-orders' DeliveryAddressDetails.tsx
// (OOP-4059) — see FulfillmentDetailsDrawer.tsx's doc comment.
export interface DeliveryAddressDetailsProps {
  deliveryDetails: {
    streetNumber?: string;
    streetType?: string;
    deliveryAddress?: {
      name?: { firstName?: string; lastName?: string };
      postalDetails?: { addressLine1?: string; addressLine2?: string; city?: string; state?: string; zipCode?: string };
    };
    firstName?: string;
    lastName?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

export const DeliveryAddressDetails: React.FC<DeliveryAddressDetailsProps> = ({ deliveryDetails }) => {
  if (!deliveryDetails) {
    return null;
  }

  const { streetNumber, streetType, deliveryAddress, firstName, lastName, city, state, zip } = deliveryDetails;

  const addressLineFromStreet = `${streetNumber ?? ''} ${streetType ?? ''}`.trim();

  const firstNameToDisplay = deliveryAddress?.name?.firstName ?? firstName ?? '';
  const lastNameToDisplay = deliveryAddress?.name?.lastName ?? lastName ?? '';

  const postalDetails = deliveryAddress?.postalDetails ?? {};
  const addressLine1ToDisplay = postalDetails.addressLine1 ?? addressLineFromStreet;
  const addressLine2ToDisplay = postalDetails.addressLine2 ?? '';
  const cityToDisplay = postalDetails.city ?? city ?? '';
  const stateToDisplay = postalDetails.state ?? state ?? '';
  const zipCodeToDisplay = postalDetails.zipCode ?? zip ?? '';

  return (
    <div className="sui-flex sui-p-4" data-testid="delivery-address-details">
      <div className="sui-flex sui-flex-row sui-gap-4 sui-pl-2">
        <span className="sui-mt-1">
          <Location size="small" />
        </span>

        <div>
          <Typography variant="h6">Delivery Address</Typography>

          <Typography variant="body-sm">
            {firstNameToDisplay} {lastNameToDisplay}
          </Typography>

          <Typography variant="body-sm" data-testid="address-line-1">
            {addressLine1ToDisplay}
          </Typography>

          {addressLine2ToDisplay && (
            <Typography variant="body-sm" data-testid="address-line-2">
              {addressLine2ToDisplay}
            </Typography>
          )}

          <Typography variant="body-sm">{[cityToDisplay, stateToDisplay, zipCodeToDisplay].filter(Boolean).join(', ')}</Typography>
        </div>
      </div>
    </div>
  );
};
